import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/SupabaseAuthContext';

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#1b0a33',
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src="/logo.png" alt="FootParadise" className="fp-pulse-soft" style={{ height: 34, maxWidth: '70%', objectFit: 'contain' }} />
        <div className="fp-bar" style={{ width: 150, height: 14 }}><div className="fp-bar-fill fp-bar-fill--unknown" /></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

export default RequireAuth;
